<template>
  <div class="container-modal-execution-schedule">
    <v-dialog
      v-model="isModalActive"
      persistent
      max-width="600"
    >
      <BaseModal
        :show-indeterminate-progress="modalSchedules.showIndeterminateProgress"
        :top-slot-content-title="title"
        :remove-button-close="modalSchedules.removeButtonClose"
        :middle-slot-content-text-highlight="modalSchedules.middleSlotContentTextHighlight"
        :middle-slot-content-text="modalSchedules.middleSlotContentText"
        :middle-check-agree="modalSchedules.middleCheckAgree"
        :bottom-buttons-align="modalSchedules.bottomButtonsAlign"
        :bottom-slot-content-button-cancel-label="modalSchedules.bottomSlotContentButtonCancelLabel"
        :bottom-slot-content-button-confirm-label="modalSchedules.bottomSlotContentButtonConfirmLabel"
        :remove-button-cancel="modalSchedules.removeButtonCancel"
        :remove-button-confirm="modalSchedules.removeButtonConfirm"
        :custom-enable-bottom-button-confirm-label="true"
        @on-cancel="modalSchedules.onCancel"
        @on-confirm="modalSchedules.onConfirm"
      >
        <div style="margin: 0 auto">
          <div>
            <p v-if="description">
              {{ description }}
            </p>
            <p><br><br>Adicione parâmetros iniciais para sua execução (Opcional)</p>

            <v-row dense>
              <v-col sm="4">
                <BaseInput
                  ref="keyInitialData"
                  v-model="initialParameters.key"
                  label="Chave"
                />
              </v-col>

              <v-col sm="4">
                <BaseInput
                  ref="valueInitialData"
                  v-model="initialParameters.value"
                  label="Valor"
                />
              </v-col>
              <v-col
                sm="1"
                class="text-right app-align-items-center"
              >
                <BaseButton
                  type="text"
                  class="app-button__link-text app-button--hide-ripple app-button--no-hover px-0"
                  :is-disabled="!initialParameters.key || !initialParameters.value"
                  @click="addInitialParameters(initialParameters)"
                >
                  {{ isEditingInitialParameters ? 'Atualizar' : 'Adicionar' }}
                </BaseButton>
                <BaseButton
                  v-if="isEditingInitialParameters"
                  type="text"
                  class="app-button__link-text app-button--hide-ripple app-button--no-hover px-2"
                  @click="cancelEditInitialParameters"
                >
                  Cancelar
                </BaseButton>
              </v-col>
            </v-row>
            <v-row
              dense
              class="mb-4"
            >
              <v-col
                cols="auto"
                sm="10"
                class="pl-0"
              >
                <template>
                  <BaseDataTable
                    v-if="visibleInitialParameters.length"
                    :headers="['', '']"
                    :items="visibleInitialParameters"
                    :hide-headers="true"
                    :hide-actions="true"
                    :disable-pagination="true"
                    background-color="transparent"
                  >
                    <template v-slot:inject-items="{ items }">
                      <tr
                        :key="items.item.key"
                      >
                        <td>
                          {{ items.item.key }}
                        </td>
                        <td>
                          {{ items.item.value }}
                        </td>
                        <td
                          class="text-right app-align-items-center"
                          style="justify-content: flex-end; min-width: 130px;"
                        >
                          <BaseButton
                            type="text"
                            class="app-button__link-text app-button--hide-ripple app-button--no-hover pa-0"
                            @click="editInitialParameters(items.index)"
                          >
                            Editar
                          </BaseButton>
                          <BaseButton
                            type="text"
                            class="app-button__link-text app-button--hide-ripple app-button--no-hover pa-0"
                            @click="removeInitialParameters(items.index)"
                          >
                            Apagar
                          </BaseButton>
                        </td>
                      </tr>
                    </template>
                  </BaseDataTable>
                </template>
              </v-col>
            </v-row>
          </div>
        </div>
      </BaseModal>
    </v-dialog>
    <BaseSnackbar
      :active-snackbar="feedback"
      :type-snackbar="feedbackColor"
      :text-snackbar="feedbackMessage"
      @closeSnackbar="feedback = !feedback"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import BaseDataTable from '../../BaseDataTable'
import BaseModal from '../../BaseModal'
import BaseSnackbarConfiguration from '../../../mixins/BaseSnackbarConfiguration'
import BaseSnackbar from '../../BaseSnackbar'

export default {
  name: 'ModalExecutionSchedule',
  components: { BaseDataTable, BaseModal, BaseSnackbar },
  mixins: [ BaseSnackbarConfiguration ],
  props: {
    isModalActive: {
      type: Boolean,
      required: true
    },
    schedule: {
      type: Object,
      required: true
    },
    title: {
      type: String,
      requiered: false,
      default: "Executar"
    },
    description: {
      type: String,
      requiered: false,
      default: null
    }
  },
  data() {
    return {
      initialParametersList: [],
      isEditingInitialParameters: false,
      initialParametersIndex: null,
      initialParameters: {
        key: '',
        value: ''
      },
      modalSchedules: {
        showIndeterminateProgress: false,
        removeButtonClose: true,
        middleSlotContentTextHighlight: "",
        middleSlotContentText: "",
        bottomButtonsAlign: "right",
        bottomSlotContentButtonCancelLabel: "Cancelar",
        bottomSlotContentButtonConfirmLabel: "Executar",
        removeButtonCancel: false,
        removeButtonConfirm: false,
        onCancel: this.closeModal,
        onConfirm: this.executionSchedule
      },
    }
  },
  computed: {
    visibleInitialParameters(){
      return this.initialParametersList.filter((sd, index) => {
        return sd.value !== '' && index !== this.initialParametersIndex
      })
    }
  },
  methods: {
    ...mapActions(['apiExecutionSchedule']),
    closeModal() {
      this.$emit("onCloseModal")
      this.initialParametersList = []
    },
    async executionSchedule(){
      const initial_parameters = Object.fromEntries(this.initialParametersList.map(({ key, value }) => [key, value]))
      try {
        const payload = {
          type: this.schedule.type,
          context: this.schedule.context,
          initiator: this.schedule.initiator,
          initial_parameters: initial_parameters || {}
        }
        await this.apiExecutionSchedule(payload)

        this.showFeedback({
          color: "success",
          message: "Tarefa executada com sucesso!",
        })
      } catch (e) {
        this.showFeedback({
          color: "error",
          message: "Erro ao executar tarefa!",
        })
      } finally {
        this.closeModal()
      }
    },
    addInitialParameters(initialData) {
      const newInitialData = {
        key: initialData.key,
        value: initialData.value
      }

      if (this.isEditingInitialParameters) {
        this.initialParametersList.splice(this.initialParametersIndex, 1, newInitialData)
        this.isEditingInitialParameters = false
        this.initialParametersIndex = null
      } else {
        this.initialParametersList.push(newInitialData)
      }

      this.initialParameters = {
        key: "",
        value: ""
      }
    },
    removeInitialParameters(index) {
      this.initialParametersIndex = index
      this.initialParametersList.splice(this.initialParametersIndex, 1)
      this.initialParametersIndex = null
    },
    editInitialParameters(index) {
      const initialData = this.initialParametersList[index]

      this.initialParameters = {
        key: initialData.key,
        value: initialData.value
      }

      this.isEditingInitialParameters = true
      this.initialParametersIndex = index
    },
    cancelEditInitialParameters() {
      this.initialParameters = {
        key: "",
        value: ""
      }
      this.isEditingInitialParameters = false
      this.initialParametersIndex = null
    }
  }
}
</script>
<style scoped>
</style>
